import { Component, OnInit } from '@angular/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { FormFieldModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { catchError, take, tap } from 'rxjs';
import { Router } from '@angular/router';
import { AfRoutes } from '../../routes';
import { FormErrorComponent } from '../../shared/components/form-error/form-error.component';

@Component({
  selector: 'af-forgot-password',
  imports: [
    ButtonModule,
    FormFieldModule,
    LabelModule,
    ReactiveFormsModule,
    TextBoxModule,
    FormErrorComponent,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup = new FormGroup({
    username: new FormControl(''),
  });

  errorMessage?: string;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.resetPasswordForm.valueChanges
      .pipe(tap(() => this.clearErrorMessage()))
      .subscribe();
  }

  resetPassword() {
    if (this.resetPasswordForm.valid) {
      const username = this.resetPasswordForm.get('username')?.value;
      this.authenticationService
        .resetPassword({ username })
        .pipe(
          tap(() => this.router.navigate([AfRoutes.confirmResetPassword])),
          take(1),
          catchError((error) => {
            this.errorMessage = error.message;
            throw error;
          })
        )
        .subscribe();
    }
  }

  private clearErrorMessage() {
    this.errorMessage = undefined;
  }
}
